<router-outlet></router-outlet>
<app-spinner></app-spinner>
<p-toast></p-toast>